import { environmentPrefix } from './commonFunctions';
import {
    ACCOUNTS_API_URL_DEV,
    ACCOUNTS_API_URL_PROD,
    ACCOUNTS_LOGOUT_URL_DEV,
    ACCOUNTS_REDIRECT_URI_DEV,
    ACCOUNTS_REDIRECT_URI_PROD,
    ACCOUNTS_REGISTRATION_URL_DEV,
    ACCOUNTS_URL_DEV,
    BACKOFFICE_URL_DEV,
    BACKOFFICE_URL_PROD,
    dashboardClientId,
    dashboardUri,
    Environment,
    API_URL_DEV,
    API_URL_PROD,
    PUBLIC_API_URL_DEV,
    PUBLIC_API_URL_PROD,
    THIRD_PARTY_REDIRECT_CALLBACK_URL_DEV,
    THIRD_PARTY_REDIRECT_CALLBACK_URL_PROD,
} from './constants';

const { hostname } = window.location;

// Determine target API environment
// REACT_APP_TARGET_ENV can override the hostname-based detection for local development
const targetEnvOverride = process.env.REACT_APP_TARGET_ENV;
const envPrefix = targetEnvOverride === 'prod' ? undefined : environmentPrefix(hostname);
const env: Environment = envPrefix ? Environment.dev : Environment.prod;

const newApiUrl = envPrefix ? API_URL_DEV.replace('{{environment}}', envPrefix) : API_URL_PROD;
const publicApiUrl = envPrefix ? PUBLIC_API_URL_DEV.replace('{{environment}}', envPrefix) : PUBLIC_API_URL_PROD;
// When on localhost, always redirect back to localhost after auth (so local dev doesn't send users to production dashboard)
const fallbackRedirect = envPrefix !== undefined || hostname === 'localhost' ? window.location.origin : dashboardUri;
const dashboardRedirectUri = process.env.REACT_APP_REDIRECT_URI || fallbackRedirect;

const thirdPartyRedirectUrl = envPrefix
    ? THIRD_PARTY_REDIRECT_CALLBACK_URL_DEV
    : THIRD_PARTY_REDIRECT_CALLBACK_URL_PROD;

const devAccountsUrlAttrs = {
    '{{environment}}': envPrefix,
    '{{redirectUri}}': process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    '{{clientId}}': dashboardClientId,
};

// eslint-disable-next-line security/detect-non-literal-regexp
const re = new RegExp(Object.keys(devAccountsUrlAttrs).join('|'), 'gi');

const accountsApiUrl = envPrefix ? ACCOUNTS_API_URL_DEV.replace('{{environment}}', envPrefix) : ACCOUNTS_API_URL_PROD;
// Prod account URLs use dashboardRedirectUri so REACT_APP_REDIRECT_URI is respected when running locally against prod APIs
const prodRedirectParam = `redirect_uri=${encodeURIComponent(dashboardRedirectUri)}`;
const accountsUrl = envPrefix
    ? ACCOUNTS_URL_DEV.replace(re, matchedKey => devAccountsUrlAttrs[matchedKey])
    : `https://accounts.airthings.com/authorize?client_id=${dashboardClientId}&${prodRedirectParam}`;
const accountsLogoutUrl = envPrefix
    ? ACCOUNTS_LOGOUT_URL_DEV.replace(re, matchedKey => devAccountsUrlAttrs[matchedKey])
    : `https://accounts.airthings.com/login?client_id=${dashboardClientId}&${prodRedirectParam}`;
export const accountsRedirectUri = envPrefix
    ? ACCOUNTS_REDIRECT_URI_DEV.replace('{{environment}}', envPrefix)
    : ACCOUNTS_REDIRECT_URI_PROD;
const backofficeUrl = envPrefix
    ? BACKOFFICE_URL_DEV.replace(re, matchedKey => devAccountsUrlAttrs[matchedKey])
    : BACKOFFICE_URL_PROD;

const accountsRegisterUrl = envPrefix
    ? ACCOUNTS_REGISTRATION_URL_DEV.replace(re, matchedKey => devAccountsUrlAttrs[matchedKey])
    : `https://accounts.airthings.com/registration?client_id=${dashboardClientId}&${prodRedirectParam}`;

const dashboardClientSecret = envPrefix
    ? 'e333140d-4a85-4e3e-8cf2-bd0a6c710e0d'
    : 'e333140d-4a85-4e3e-8cf2-bd0a6c710aaa';
export const cookieDomain = hostname === 'localhost' ? 'localhost' : '.airthings.com';

// REACT_APP_HIGHCHARTS_MENU_ENABLED: 'false' to disable Highcharts export menu; when unset, menu is enabled
const highchartsMenuEnabled = process.env.REACT_APP_HIGHCHARTS_MENU_ENABLED !== 'false';

const config = {
    newApiUrl,
    publicApiUrl,
    accountsApiUrl,
    accountsLogoutUrl,
    accountsUrl,
    accountsRegisterUrl,
    backofficeUrl,
    dashboardClientSecret,
    dashboardClientId,
    env,
    cookieDomain,
    dashboardRedirectUri,
    thirdPartyRedirectUrl,
    highchartsMenuEnabled,
};

// Explicit exports for clarity:
// - targetEnv: Which API environment we're talking to (dev/prod) - affected by REACT_APP_TARGET_ENV
// - isLocalDev: Whether running on localhost - NOT affected by env overrides (used for analytics, debug features)
export const targetEnv = env;
export const isLocalDev = hostname === 'localhost';

export default config;
